import { z } from 'zod'

export const tenantDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  status: z.string(),
  description: z.string().nullable().optional(),
  plan: z.string().nullable().optional(),
  maxUsers: z.number().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string().nullable().optional(),
})

export type TenantDto = z.infer<typeof tenantDtoSchema>

export const tenantListDataSchema = z.array(tenantDtoSchema)

export const pagedTenantDataSchema = z.object({
  items: z.array(tenantDtoSchema),
  totalCount: z.number(),
  page: z.number(),
  pageSize: z.number(),
})

export const pagedTenantResponseSchema = z.object({
  success: z.boolean(),
  data: pagedTenantDataSchema,
})

export const tenantSingleResponseSchema = z.object({
  success: z.boolean(),
  data: tenantDtoSchema,
})

export interface CreateSimpleTenantRequest {
  name: string
  slug: string
  adminEmail: string
  adminDisplayName: string
}

export interface UpdateTenantRequest {
  name?: string
  slug?: string
  description?: string
}
